<ng-container *transloco="let t">
  <div class="w-full">
    <div class="mx-auto w-full max-w-screen-md pt-16">
      <IProfileForm
        [user]="user()!"
        (profileFormChanges)="submitForm($event)"
        [loading]="submitLoading()"
        (onChangePassword)="changePassword()"
      />
    </div>
  </div>
</ng-container>
